import { gsap } from 'gsap/all';

const DISTANCE = 40;
const DURATION = 1;

const focusableSelector = 'a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])';
let $activeTarget = null;
let initialized = false;

export function initContactAnimation () {
    if (initialized) return;

    const $contact = document.querySelector('.contact:not(.contact--big) .contact__contact');
    const $newsletter = document.querySelector('.contact:not(.contact--big) .contact__newsletter');

    if ($contact && $newsletter) {
        const $focusables = Array.from($contact.querySelectorAll(focusableSelector)).concat(Array.from($newsletter.querySelectorAll(focusableSelector)));
        const scope = { $contact, $newsletter };
        $contact.addEventListener('mouseenter', onMouseEnter.bind(scope));
        $newsletter.addEventListener('mouseenter', onMouseEnter.bind(scope));
        $focusables.forEach(($item) => {
            $item.addEventListener('focusin', onFocusIn.bind(scope));
        });

        if (!$activeTarget) $activeTarget = $newsletter;
    }

    initialized = true;
}

function setFocus ($target) {
    if ($target === $activeTarget) return;

    const isContact = this.$contact === $target;
    const isNewsletter = this.$newsletter === $target;

    gsap.killTweensOf(this.$newsletter);
    gsap.killTweensOf(this.$contact);

    const nlTl = gsap.timeline();
    const coTl = gsap.timeline();

    nlTl.to(this.$newsletter, {
        x:        DISTANCE,
        duration: DURATION / 2,
        // ease:     'Power4.easeIn',
    });

    nlTl.set(this.$newsletter, {
        zIndex: isNewsletter ? 1 : 0,
    });

    nlTl.to(this.$newsletter, {
        x:        0,
        duration: DURATION / 2,
        // ease:     'Power2.easeOut',
    });

    coTl.to(this.$contact, {
        x:        -DISTANCE,
        duration: DURATION / 2,
        // ease:     'Power4.easeIn',
    });

    coTl.set(this.$contact, {
        zIndex: isContact ? 1 : 0,
    });

    coTl.to(this.$contact, {
        x:        0,
        duration: DURATION / 2,
        // ease:     'Power2.easeOut',
    });

    $activeTarget = $target;
}

function onMouseEnter (e) {
    setFocus.call(this, e.currentTarget);
}

function onFocusIn (e) {
    if (this.$newsletter.contains(e.currentTarget)) {
        setFocus.call(this, this.$newsletter);
    }
    else {
        setFocus.call(this, this.$contact);
    }
}
